export enum EEmailStatus {
  SENT = 'SENT',
  PROCESSED = 'PROCESSED',
  DROPPED = 'DROPPED',
  DEFERRED = 'DEFERRED',
  DELIVERED = 'DELIVERED',
  BOUNCE = 'BOUNCE',
  BLOCKED = 'BLOCKED'
}
